import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { GetCompanyRequest, GetCompanyResponse, GetCompanyUuidRequest, GetCompanyUuidResponse } from './types/TCompanyServices';

const URL_Prefix = '/company';

export const companyService = createApi({
    reducerPath: 'companyService',
    baseQuery: getBaseQuery,
    tagTypes: ['Company'],
    endpoints: (builder) => ({
        getCompany: builder.query<GetCompanyResponse, GetCompanyRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/`,
                method: 'GET',
                params: params,
            }),
        }),
        getCompanyUuid: builder.query<GetCompanyUuidResponse, GetCompanyUuidRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/${params.uuid}/`,
                method: 'GET',
                params: params,
            }),
        }),
    }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
    useGetCompanyQuery,
    useLazyGetCompanyQuery,
    useGetCompanyUuidQuery,
    useLazyGetCompanyUuidQuery
} = companyService;